/**
 * Preserved environmental gradient strings — extracted verbatim from the
 * shipped editor/gallery so a single source of truth exists for the
 * "white top status-bar blend" and "dark bottom contrast fade".
 *
 *   • galleryTopFadeGradient   — LayoutVersionSlider.js ~2413
 *   • editorBottomFadeGradient — UploadFloor.js ~16830 and
 *                                 LayoutVersionSlider.js ~3609
 *
 * Do not tune. The opacity/stops are the shipped values; consumers should
 * import these so future tuning happens in one place.
 */

export const galleryTopFadeGradient =
  "linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)";

export const editorBottomFadeGradient =
  "linear-gradient(to bottom, rgba(102,102,106,0) 0%, rgba(102,102,106,0.06) 25%, rgba(102,102,106,0.25) 50%, rgba(102,102,106,0.56) 75%, rgba(102,102,106,0.85) 87.5%, rgba(102,102,106,1) 100%)";
